


















import Component from "vue-class-component";
import Vue from "vue";
import {Ref} from "vue-property-decorator";

@Component
export default class About extends Vue {
  @Ref() readonly aboutElement!: HTMLDivElement

  mounted() {
    this.$nextTick(() => {
      const size = {width: this.aboutElement.clientWidth, height: this.aboutElement.clientHeight};
      this.$emit('resized', size)
    })
  }
}
